import { render, staticRenderFns } from "./typelist.vue?vue&type=template&id=371f8708"
import script from "./typelist.vue?vue&type=script&lang=js"
export * from "./typelist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports